<template>
  <div id="assessment-image" style="flex-shrink: 1; min-height: 0; min-width: 0;">
    <v-img contain v-if="this.panel.display === 'banner'" :src="src"></v-img>
    <v-img contain v-if="this.panel.display === 'gif'" :src="src"></v-img>
    <video contain v-if="this.panel.display === 'animated'"
      @play="playVideo"
      ref="videoEl"
      :muted="videoMuted"
      :key="src"
      autoplay
      loop
      preload="yes"
      playsinline
      v-playback-rate="videoSpeed"
      style="width: 100%"
      webkit-playsinline>
      <source :src="src" type="video/mp4">
    </video>
  </div>
</template>

<script>
  import serviceworker from '@/components/layouts/ServiceWorker'
  import warning from '@/components/layouts/Warning'
  import { mapGetters } from 'vuex'
  import ui from '@/mixins/ui'

  export default {
    name: 'AssessmentImage',
    components: { serviceworker, warning },
    mixins: [ ui ],
    data() {
      return {
        error: false,
        message: '',
        error: { start: false },
        hasSound: false,
      }
    },
    props: {
        toolbarOffset: {
          type: Number,
          default: 0,
        },
        muteVideo: {
          type: Boolean,
          default: true,
        },
    },
    directives: {
      playbackRate(el, binding) {
        el.playbackRate = binding.value
      }
    },
    computed: {
      tone() {
        let tone = 'caucasian'
        try {
          tone = this.settings('skinTone')
        }
        catch (e) {}
        return tone
      },
      videoMuted() {
        if (this.hasSound) {
          return this.muteVideo;
        } else {
          return true;
        }
      },
      src() {
        if (this.panel.display === 'banner') {
          return this.pathForImages + 'img/banner/' + this.tone + '/' + (this.panel.options.image || this.panel.name) + '.jpg'
        } else if (this.panel.display === 'animated') {
          return this.pathForImages + 'img/animated/'  + this.tone + '/' + (this.panel.options.image || this.panel.name) + '.mp4'
        } else if (this.panel.display === 'gif') {
          return 'static/images/shared/gif/' + (this.panel.options.image || this.panel.name) + '.gif'
        }
      },
      maxTopHeight() {
        return {
          maxHeight: this.maxHeight(this.toolbarOffset).toString() + 'px',
        }
      },
      videoSpeed() {
        const selected = this.panel?.responses?.find(r => r.selected)

        return (!selected) ? "1.0" : this.getPlaybackRate(this.panel.name, selected.value)
      },
      ...mapGetters({
        getTrack: 'v4/track/current',
        pathForImages: 'v4/pathForImages',
        panel: 'v4/panel/current',
        settings: 'v4/settings/get',
      })
    },
    methods: {
      noImage(event) {
        console.log('Missing:' + event.target.src)
        event.target.error = null
        event.target.src = `${this.pathForImages}app/common/placeholder.png`
      },
      playVideo() {
        this.determineIfVideoHasSound();
      },
      loadVideo() {
        const videoEl = this.$refs.videoEl
        videoEl.load()
        videoEl.addEventListener('ended', function() {
          this.load()
        })
      },
      determineIfVideoHasSound() {
        const videoEl = this.$refs.videoEl

        if (videoEl?.audioTracks?.length > 0 || videoEl?.mozHasAudio || Boolean(videoEl?.webkitAudioDecodedByteCount)) {
          this.hasSound = true;
        } else {
          this.hasSound = false;
        }
      }
    },
    mounted() {
      if (this.panel.display === 'animated') {
        this.loadVideo()
      }
    },
    watch: {
      hasSound() {
        this.$emit('showVolumeControl', this.hasSound);
      }
    }
  }
</script>

<style scoped>
  .v-image, video {
    max-width: 100%;
    max-height: 100%;
  }
</style>